<template>
    <v-card>
      <v-img
        src='../assets/Home/grafika1.jpg'
        height="300"
        cover
        class="graf"
      >
        <div class="d-flex flex-column fill-height justify-center align-center">
          <p class="text-h4 mb-4" color="primary">
            Kołdry z wełny alpak
          </p>
          <p class="subheading ">
            Popraw komfort swojego snu
          </p>
          <br />
          <v-btn color="primary" @click="$router.push('/sklep_koldry')">Sprawdź teraz!</v-btn>
          <p class="text-subtitle-1 text-center mt-16 mb-4">
            Naszą misją jest dostarczanie najwyższej jakości kołder z runa alpak, które zapewniają naszym klientom wyjątkowy komfort snu, ciepło i elegancję. <br /> Nasza firma kładzie nacisk na etyczne i ekologiczne praktyki w procesie produkcji, by dostarczać produkty, które są nie tylko luksusowe, ale także przyjazne dla środowiska. 
          </p>
        </div>
      </v-img>
    </v-card>
    
    <br />
    <v-row>
      <v-col cols="1"></v-col>
      <v-col cols="10" class="ma-5">
        <v-row>
          <p class="text-h4">
            Twój nowy niezbędnik na noc
          </p>
        </v-row>
        <v-row class="mt-10">
          <p class="text-h5  text-primary">
            Ciesz się najlepszym snem z kołdrą wypełnioną włóknem alpaki
          </p>
        </v-row>
        <v-row class="mt-7">
          <p class="text-subtitle-1 ">
            Nocne poty, alergie, uczucie gorąca, a potem zimna… wiele może stanąć na drodze do dobrego snu. Nasze kołdry z alpaki zaprojektowane w sposób zrównoważony mogą w tym pomóc. Każda kołdra jest wypełniona naturalnym luksusowym włóknem alpaki, które otrzymujemy od alpak w naszym Alpakowym Raju.
          </p>
        </v-row>
        <v-row class="mt-10">
          <p class="text-h5  text-primary">
            Dlaczego warto wybrać kołdrę wykonaną z runa alpak?
          </p>
        </v-row>
        <v-row class="mt-7">
          <p class="text-subtitle-1 font-weight-bold">Ciepło i izolacja</p>
        </v-row>
        <v-row>
          <p class="text-subtitle-1 ">
            Runo alpak jest znane z doskonałej izolacji cieplnej.
            Alpaki żyją w trudnych warunkach klimatycznych w Andach, co sprawia, że
            ich runo jest doskonale przystosowane do utrzymania ciepła. Kołdra z runa
            alpak jest więc doskonałą opcją, jeśli chcesz spać ciepło i komfortowo,
            zwłaszcza w chłodniejszych porach roku.
          </p>
        </v-row>
        <v-row class="mt-7">
          <p class="text-subtitle-1 font-weight-bold">Miękkość i wygoda</p>
        </v-row>
        <v-row>
          <p class="text-subtitle-1 ">
            Runo alpak jest niezwykle miękkie i delikatne dla
            skóry. To sprawia, że kołdra z tego materiału jest bardzo wygodna i
            przyjemna w dotyku. Może to przyczynić się do lepszego snu i ogólnego
            komfortu podczas spania.
          </p>
        </v-row>
        <v-row class="mt-7">
          <p class="text-subtitle-1 font-weight-bold">Hypoalergiczność</p>
        </v-row>
        <v-row>
          <p class="text-subtitle-1 ">
            Runo alpak jest hypoalergiczne, co oznacza, że jest
            mniej prawdopodobne, że wywoła reakcje alergiczne u osób wrażliwych na
            alergeny. Dlatego kołdry z tego materiału są odpowiednie dla osób z
            alergią.
          </p>
        </v-row>
        <v-row class="mt-7">
          <p class="text-subtitle-1 font-weight-bold">Trwałość</p>
        </v-row>
        <v-row>
          <p class="text-subtitle-1">
            Runo alpak jest wyjątkowo trwałe i odporne na zużycie. Kołdra z
            tego materiału może służyć przez wiele lat, co sprawia, że jest dobrą
            inwestycją w jakość Twojego snu.
          </p>
        </v-row>
        <v-row class="mt-7">
          <p class="subtitle-1 font-weight-bold">Regulacja temperatury</p>
        </v-row>
        <v-row>
          <p class="text-subtitle-1 ">
            Runo alpak ma zdolność do regulacji
            temperatury, co oznacza, że może pomóc w utrzymaniu odpowiedniego
            ciepła podczas snu. Działa to zarówno w chłodniejszych, jak i cieplejszych
            warunkach, zapewniając komfortową temperaturę pod kołdrą.
          </p>
        </v-row>

        <v-row class="mt-16 align-center">
          <v-col cols="3">
            <v-img src='../assets/Home/pictogram1.png' height="200"></v-img>
          </v-col>
          <v-col cols="3">
            <v-img src='../assets/Home/pictogram2.png' height="200"></v-img>
          </v-col>
          <v-col cols="3">
            <v-img src='../assets/Home/pictogram3.png' height="200"></v-img>
          </v-col>
          <v-col cols="3">
            <v-img src='../assets/Home/pictogram4.png' height="200"></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" class="text-h5 text-primary text-center">
            Przeciwgrzybicza i przeciwdrobnoustrojowa
          </v-col>
          <v-col cols="3" class="text-h5 text-primary text-center">
            Hipoalergiczna
          </v-col>
          <v-col cols="3" class="text-h5 text-primary text-center">
            Reguluje temperaturę ciała
          </v-col>
          <v-col cols="3" class="text-h5 text-primary text-center">
            Odporna na roztocza
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>

    <v-parallax
      src="../assets/Home/grafika2.jpg"
      height="400"
    >
      <div class="d-flex flex-column fill-height justify-center align-center text-white">
        <h1 class="text-h4 font-weight-normal mb-4 text-center">
          Dlaczego wełna z alpaki jest najlepszym naturalnym materiałem wypełnieniowym?
        </h1>
        <h4 class="text-h5 text-center">
          TRWAŁA, PRZYJAZNA DLA ŚRODOWISKA I NATURALNIE JEDWABNA
        </h4>
        <h4 class="text-subtitle-1  mt-16 text-center">
          W przeciwieństwie do innych tradycyjnych materiałów, takich jak wełna owcza, wełna z alpaki jest bardzo miękka, ciepła, lekka, hipoalergiczna i nie powoduje uczucia swędzenia.
        </h4>
        <h4 class="text-subtitle-1  mt-3 text-center">
          Dodatkowo ma niezwykle lekki wpływ na środowisko! Przekształcenie surowego włókna alpaki w przędzę nie wymaga stosowania silnych środków chemicznych, w przeciwieństwie do innych wełen, kaszmiru czy bawełny.
        </h4>
        <h4 class="text-subtitle-1  mt-3 text-center">
          To sprawia, że alpaka jest idealną tkaniną do produkcji luksusowych i zrównoważonych kołder wypełnionych włóknem alpaki, poduszek, odzieży i nie tylko.
        </h4>
        
      </div>
    </v-parallax>

    <br />

    <v-row class="align-center">
      <v-col cols="1"></v-col>
      <v-col cols="5" class="mt-16">
        <v-carousel cycle :show-arrows="false" height="400">
          <v-carousel-item
            v-for="(item,i) in items"
            :key="i"
            :src="item.src"
            cover
          ></v-carousel-item>
        </v-carousel>
      </v-col>
      <v-col cols="5" class="mt-16 mt-2">
        <v-row>
          <p class="text-h4 text-primary">
            Nasza wizja
          </p>
        </v-row>
        <v-row class="mt-7">
          <p class="text-subtitle-1 ">
            Jesteśmy dumni z tego, że dostarczamy wyjątkowe produkty dla miłośników komfortu oraz luksusu. Nasza wizja opiera się na dążeniu do ustanowienia nowych standardów jakości w świecie snu, oferując kołdry z runa alpak, które przekształcają nocny wypoczynek w niezapomniane doświadczenie.
          </p>
        </v-row>
        <v-row class="mt-7">
          <p class="text-subtitle-1 ">
            Chcemy, aby nasze kołdry stały się synonimem doskonałości i zrównoważonego stylu życia. Widzimy siebie jako firmę, która nie tylko dostarcza produkty najwyższej jakości, ale także inspiruje naszych klientów do pielęgnowania swojego ciała i umysłu poprzez zdrowy sen. Nasza wizja zakłada, że nasze kołdry staną się nieodłącznym elementem codziennego relaksu, w którym każda noc jest wyjątkowa i odprężająca.
          </p>
        </v-row>
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>

    <v-row class="align-center">
      <v-col cols="1"></v-col>
      <v-col cols="5" class="mt-16">
        <v-row class="mt-7 justify-end">
          <p class="text-h4 text-primary text-end">
            Dostarczanie najwyżej jakości kołder jest naszym celem
          </p>
        </v-row>
        <v-row class="mt-7">
          <p class="text-subtitle-1  text-end">
            Chcemy inspirować naszych klientów do czerpania radości z każdej nocy spędzonej pod naszymi kołdrami, oferując im spokojny sen i komfort, który pomaga im cieszyć się pełnią życia.
          </p>
        </v-row>
        <v-row class="mt-7 justify-center">
          <div class="d-flex flex-column fill-height justify-center align-center">
            <v-btn color="primary" @click="$router.push('/sklep_koldry')">Sprawdź nasze produkty tutaj!</v-btn>
          </div>
        </v-row>
      </v-col>
      <v-col cols="5" class="mt-16">
        <v-img
        src='../assets/Home/grafika3.jpg'
        height="500"
        cover
        ></v-img>
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>
    <br />
</template>

<script>
export default {
  props: ['items'],
  data () {
    return {
    }
  },
}
</script>
